<script setup lang="ts">
import { ref } from 'vue'
import { formatDuration } from '~/helpers/formatters'
import { currentUser } from '@/lib/currentUser'
import LoginCertificate from '@/ui-kit/login/Certificate.vue'
import type { EntryPoint } from './types'

defineProps<{ entrypoints: EntryPoint[] }>()

const certificateModal = ref(false)
const emptyQuery = new URLSearchParams()
</script>

<template>
  <div class="d-flex flex-column">
    <v-rich-modal v-model="certificateModal" title="Сертификат">
      <LoginCertificate standalone :query="emptyQuery" @close="certificateModal = false" />
    </v-rich-modal>

    <div v-if="!currentUser.id" class="teacher-dashboard__demo-card mb-3">
      Добро пожаловать в Демо-кабинет учителя на сайте МирГоворит!
    </div>

    <p class="text-body mb-3">
      Для того чтобы начать работу в личном кабинете, необходимо пройти один из следующих семинаров:
    </p>

    <div class="teacher-dashboard__entrypoints-grid">
      <a v-for="item in entrypoints" :key="item.title" class="teacher-dashboard__entrypoint-card" :href="item.cardLink">
        <span class="teacher-dashboard__entrypoint-title mb-half" v-text="item.title" />
        <span class="d-flex align-center teacher-dashboard__entrypoint-duration mb-1">
          <v-icon class="mr-1 gray-text" size="16">mdi-clock</v-icon>
          {{ formatDuration(item.duration) }}
        </span>
        <p class="text-caption mb-3 flex-spacer" v-text="item.description" />
        <v-button mode="primary large" :href="item.cardLink">К семинару</v-button>
      </a>
    </div>

    <div class="mt-2">
      <v-button v-if="currentUser.id" class="mt-1" mode="primary flat" @click="certificateModal = true">
        У меня уже есть сертификат
      </v-button>
    </div>
  </div>
</template>
